import Header from "../components/Header";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import backgroundImage from "../img/banner/ZTO-Banner.png";
import "../css/contactForm.css";
import axios from "axios";
import { API_URL_All } from "../api";

const ContactForm = () => {
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [content, setContent] = useState("");
  const [selectedOfficeIndex, setSelectedOfficeIndex] = useState(0);

  const handleFullNameChange = (e) => {
    setFullName(e.target.value);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fullName || !phoneNumber || !content) {
      toast.error("Vui lòng điền đầy đủ thông tin", { position: "top-right" });
      return;
    }

    try {
      const contactData = {
        name: fullName,
        numberPhone: phoneNumber,
        email: email,
        message: content,
      };

      const response = await axios.post(`${API_URL_All}/api/contact-exploration/create`, contactData);

      if (response.data.success) {
        toast.success(
          "Chúng tôi đã nhận được lời nhắn và sẽ liên lạc sớm nhất đến quý khách",
          { position: "top-right" }
        );
        
        // Reset form
        setFullName("");
        setPhoneNumber("");
        setEmail("");
        setContent("");
      }
    } catch (error) {
      console.error("Error submitting contact form:", error);
      toast.error("Có lỗi xảy ra khi gửi thông tin. Vui lòng thử lại!", {
        position: "top-right",
      });
    }
  };

  const contactWays = [
    {
      icon: "fas fa-phone-alt",
      title: "Điện thoại",
      content: "036.475.8606",
      link: "tel:0364758606",
    },
    {
      icon: "fas fa-envelope",
      title: "Email",
      content: "ztovietnam.vn@gmail.com",
      link: "mailto:ztovietnam.vn@gmail.com",
    },
    {
      icon: "fas fa-clock",
      title: "Giờ làm việc",
      content: "Thứ 2 - Thứ 7: 8:00 - 18:00",
      link: null,
    },
    {
      icon: "fas fa-map-marker-alt",
      title: "Địa chỉ",
      content: "41B P. Lý Quốc Sư, Hàng Trống, Hoàn Kiếm, Hà Nội, Việt Nam",
      link: null,
    },
  ];

  const offices = [
    {
      name: "Văn phòng Hà Nội",
      address: "41B P. Lý Quốc Sư, Hàng Trống, Hoàn Kiếm, Hà Nội, Việt Nam",
      phone: "036.475.8606",
      email: "ztovietnam.vn@gmail.com",
      mapUrl:
        "https://www.google.com/maps?q=41b+P.+L%C3%BD+Qu%E1%BB%91c+S%C6%B0,+H%C3%A0ng+Tr%E1%BB%91ng,+Ho%C3%A0n+Ki%E1%BA%BFm,+H%C3%A0+N%E1%BB%99i&output=embed",
    },
    {
      name: "Văn phòng TP Hồ Chí Minh",
      address: "48 Tôn Đức Thắng, Bến Nghé, Quận 1, Hồ Chí Minh, Việt Nam",
      phone: "036.475.8606",
      email: "ztovietnam.vn@gmail.com",
      mapUrl:
        "https://www.google.com/maps?q=48+T%C3%B4n+%C4%90%E1%BB%A9c+Th%E1%BA%AFng,+B%E1%BA%BFn+Ngh%C3%A9,+Qu%E1%BA%ADn+1,+H%E1%BB%93+Ch%C3%AD+Minh&output=embed",
    },
  ];

  return (
    <div className="contact-page">
      <Header />

      {/* Banner with Breadcrumb */}
      <Banner
        title="Liên hệ"
        backgroundImage={backgroundImage}
        breadcrumb={
          <>
            <Link to={"/"} className="text-white p-2">
              Trang chủ
            </Link>
            <span>{">"}</span>
            <span className="text-white p-2">Liên hệ</span>
          </>
        }
      />

      {/* Contact Ways Section */}
      <div className="contact-ways-section py-5">
        <div className="container">
          <h3 className="text-center contact-ways-section-title">THAY ĐỔI CÁCH THỨC VẬN CHUYỂN</h3>
          <p className="text-center contact-ways-section-subtitle">Bạn đã sẵn sàng bắt đầu hành trình cùng ZTO Việt Nam chưa? Chúng tôi luôn sẵn sàng hỗ trợ bạn trên mọi chặng đường.</p>
          <div className="row g-4 mt-4">
            {contactWays.map((way, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-12">
                <div className="contact-way-card">
                  {way.link ? (
                    <a href={way.link} className="contact-way-link">
                      <div className="contact-way-icon">
                        <i className={way.icon}></i>
                      </div>
                      <h5 className="contact-way-title">{way.title}</h5>
                      <p className="contact-way-content">{way.content}</p>
                    </a>
                  ) : (
                    <>
                      <div className="contact-way-icon">
                        <i className={way.icon}></i>
                      </div>
                      <h5 className="contact-way-title">{way.title}</h5>
                      <p className="contact-way-content">{way.content}</p>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-form-section py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 col-12">
              <div className="contact-form-wrapper">
                <div className="text-center">
                  <h2 className="section-title border-0 p-0">HÃY LIÊN HỆ VỚI CHÚNG TÔI</h2>
                </div>
                <Form onSubmit={handleSubmit} className="contact-form">
                  <Form.Group controlId="formFullName" className="mb-3">
                    <Form.Label>
                      Họ và tên <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nhập họ và tên của bạn"
                      value={fullName}
                      onChange={handleFullNameChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group controlId="formPhoneNumber" className="mb-3">
                    <Form.Label>
                      Số điện thoại <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nhập số điện thoại của bạn"
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group controlId="formEmail" className="mb-3">
                    <Form.Label>
                      Email
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Nhập email của bạn (không bắt buộc)"
                      value={email}
                      onChange={handleEmailChange}
                    />
                  </Form.Group>
                  <Form.Group controlId="formContent" className="mb-4">
                    <Form.Label>
                      Lời nhắn <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      placeholder="Nhập nội dung tin nhắn của bạn"
                      value={content}
                      onChange={handleContentChange}
                      required
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 btn-send-message"
                  >
                    <i className="fas fa-paper-plane me-2"></i>
                    Gửi tin nhắn
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="map-section py-5 mb-5">
        <div className="container px-0">
          <div className="row g-5">
            {/* Office List */}
            <div className="col-lg-5 col-md-5 col-12">
              <div className="office-list-wrapper">
                <div className="office-list">
                  {offices.map((office, index) => (
                    <div
                      key={index}
                      className={`office-item ${
                        selectedOfficeIndex === index ? "active" : ""
                      }`}
                      onClick={() => setSelectedOfficeIndex(index)}
                      role="button"
                      tabIndex={0}
                    >
                      <h4 className="office-name">
                        <i className="fas fa-building me-2"></i>
                        {office.name}
                      </h4>
                      <div className="office-details">
                        <div className="office-detail-item">
                          <i className="fas fa-map-marker-alt"></i>
                          <span>{office.address}</span>
                        </div>
                        <div className="office-detail-item">
                          <i className="fas fa-phone"></i>
                          <a href={`tel:${office.phone.replace(/\./g, "")}`}>
                            {office.phone}
                          </a>
                        </div>
                        <div className="office-detail-item">
                          <i className="fas fa-envelope"></i>
                          <a href={`mailto:${office.email}`}>{office.email}</a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Google Map */}
            <div className="col-lg-7 col-md-7 col-12">
              <div className="map-wrapper">
                <iframe
                  key={selectedOfficeIndex}
                  src={offices[selectedOfficeIndex].mapUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="ZTO Việt Nam Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactForm;
